<template>
    <div>
        <br>
        <div v-if="secondsToCheckout == 0">
            <a class="btn btn-success"
            @click="displayCheckoutQR()"
            v-if="checkedIn">
                Ulos QR Koodi
            </a>

            <a class="btn btn-success"
            @click="displayCheckinQR()"
            v-else>
                Sisään QR Koodi
            </a>

            <div class="qr-code">
                <div v-if="showCheckinQR" v-html="checkinQR"></div>
                <div v-if="showCheckoutQR" v-html="checkoutQR"></div>
            </div>
        </div>
        <div v-else>
            <h1>Aikaa jäljellä: {{ stringTimeToCheckout }}</h1>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import Swal from 'sweetalert2'

    export default {
        props: {
            datetime: {
                type: Number,
                default: 0
            },
            activityId: {
                type: Number,
                default: 0
            },
        },
        data: function () {
            return {
                showCheckinQR: false,
                showCheckoutQR: false,
                checkedIn: false,
                secondsToCheckout: 0,
                stringTimeToCheckout: "",
                checkinQR: '',
                checkoutQR: ''
            }
        },
        mounted: function () {
            this.checkinStatus();
            setInterval(() => {
                this.updateCheckoutTime()
            }, 1000)
        },
        methods:
            {
                displayCheckinQR() {
                    this.getCheckinQR();
                    this.showCheckinQR = !this.showCheckinQR;
                    this.showCheckoutQR = false;
                },
                displayCheckoutQR() {
                    this.getCheckoutQR();
                    this.showCheckoutQR = !this.showCheckoutQR;
                    this.showCheckinQR = false;
                },
                checkinStatus: function () {
                    let es = new EventSource('/api/checkin/activity/' + this.activityId + '/status');

                    es.addEventListener('status', event => {
                        let data = JSON.parse(event.data);
                        this.checkedIn = data.checked_in;
                        this.secondsToCheckout = data.seconds_to_checkout;
                        if(this.checkedIn == true){
                            es.close();
                        }
                    }, false);

                    es.addEventListener('timeout', event => {
                        es.close();
                    }, false);
                },
                getCheckinQR: function () {
                    axios.post('/api/checkin/qr/' + this.activityId, {
                        'activity_date': this.datetime
                    })
                    .then(response => {
                        this.checkinQR = response.data;
                        //this.checkinStatus();
                    })
                    .catch(response => Swal(response.data.errors.title));
                },
                getCheckoutQR: function () {
                    axios.post('/api/checkout/qr/' + this.activityId, {
                        'activity_date': this.datetime
                    }).then(response => {
                        this.checkoutQR = response.data;
                        //this.checkinStatus();
                    })
                    .catch(response => Swal(response.data.errors.title));
                },
                updateCheckoutTime: function (){
                    if (this.secondsToCheckout > 0) {
                        this.secondsToCheckout = this.secondsToCheckout - 1;
                    } else {
                        this.secondsToCheckout = 0;
                    }

                    var minutes = ~~(this.secondsToCheckout / 60);
                    var seconds = this.secondsToCheckout - minutes * 60;

                    this.stringTimeToCheckout = minutes.toString().padStart(2, "0") + ":" + seconds.toString().padStart(2, "0")

                },

            },
        events:
            {
                onSelectedDateChange: function (datetime) {
                    this.datetime = datetime;
                    this.checkinStatus();
                },
            }
    }
</script>